import { COLORS } from '@btime/constants'
import { propEq, props } from 'ramda'
import { useFilterActions, useFilterState } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Grid } from '../../packages/kiti/components/structure/Grid'
import DropdownLink from '../navigation/DropdownLink'
import Icon from '../../packages/kiti/components/shapes/Icon'
import Input from './Input'

const SearchInput = ({ options, value, onStopTyping, ...props }) => {
  const { t } = useTranslation()

  const { search, searchType } = useFilterState()
  const { setSearch, setSearchType } = useFilterActions()

  value = value || search
  onStopTyping = onStopTyping || setSearch

  const hasOptions = !!options
  let iconName = 'BsSearch'
  if (hasOptions) {
    iconName = options.find(propEq('value', searchType))?.icon || iconName
  }
  const searchIcon = <Icon name={iconName} color={COLORS.dark3} size={0.9} />

  return (
    <Input
      leftPadding={hasOptions ? '3rem' : '2.5rem'}
      leftContent={
        hasOptions ? (
          <DropdownLink
            options={options}
            onChange={setSearchType}
            actionContent={
              <Grid gutter={0.1} align="center" justify="flex-end">
                {searchIcon}
                <Icon name="RiArrowDownSFill" color={COLORS.dark3} size={0.9} />
              </Grid>
            }
          />
        ) : (
          searchIcon
        )
      }
      small
      placeholder={t('search') + '...'}
      onStopTyping={onStopTyping}
      value={value}
      {...props}
    />
  )
}

export default SearchInput
